import { AlertCircle } from 'lucide-react';
import { Button } from "@/components/ui/button";

interface ErrorDisplayProps {
  message: string;
  onRetry: () => void;
  onGoBack: () => void;
}

export const ErrorDisplay = ({ message, onRetry, onGoBack }: ErrorDisplayProps) => (
  <div className="flex-1 flex flex-col items-center justify-center p-4">
    <AlertCircle className="h-10 w-10 text-red-500 mb-4" />
    <span className="text-red-500 text-center mb-4">{message}</span>
    <div className="space-x-4">
      <Button variant="outline" onClick={onGoBack}>
        Go back
      </Button>
      <Button onClick={onRetry}>
        Try again
      </Button>
    </div>
  </div>
);